import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

import Wheel from './elements/Wheel';

class Gallery extends Component {
  render() {
    return (
      <Wrapper>
        <Wheel />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  text-align: center;
  width: 90vw;
  @media (min-width: ${media.smup}) {
    width: 767px;
  }
`;

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.js